export default __webpack_public_path__ + "img/app-page/screen3Android.eb6ebc1becbec64375477dd8d1db5de5.png";